import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getBanner, removeBanner, toggleBanner } from 'slice/bannerSlice';
import AdminTable from 'common/AdminTable';
import { FaPlus } from 'react-icons/fa';

const getImageUrl = (image) => {
  if (!image) return null;
  if (/^https?:\/\//i.test(image)) return image;

  const backendBase = (process.env.REACT_APP_BACKEND || '').replace(/\/+$/, '');
  if (!backendBase) return image;

  const normalizedPath = String(image).replace(/^\/+/, '');
  const fullPath = normalizedPath.startsWith('uploads/')
    ? normalizedPath
    : `uploads/${normalizedPath}`;
  return `${backendBase}/${fullPath}`;
};

const BannerList = () => {
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const bannerState = useSelector((state) => state.banner);
    const banners = Array.isArray(bannerState?.data) ? bannerState.data : [];
    const loading = bannerState?.loading;

    const tableHeaders = [
        {
            Header: 'ID',
            accessor: 'id',
        },
        {
            Header: 'Heading',
            accessor: 'heading',
        },
        {
            Header: 'Image',
            accessor: 'image',
            Cell: ({ row }) => (
                <img
                    src={getImageUrl(row.original.image)}
                    alt={row.original.heading}
                    className="banner-thumb"
                    onError={(e) => { e.target.style.display = 'none'; }}
                />
            ),
        },
        {
            Header: 'Status',
            accessor: 'is_active',
            Cell: ({ row }) => (
                <span className={`badge ${row.original.is_active ? 'badge-success' : 'badge-danger'}`}>
                    {row.original.is_active ? 'Active' : 'Inactive'}
                </span>
            )
        },
        {
            Header: 'Actions',
            accessor: 'actions',
            Cell: ({ row }) => (
                <div className="d-flex flex-wrap" style={{ gap: 6 }}>
                    <button
                        className="btn btn-sm btn-info"
                        onClick={() => navigate(`/banner/update/${row.original.id}`)}
                    >
                        Edit
                    </button>
                    <button
                        className={`btn btn-sm ${row.original.is_active ? 'btn-warning' : 'btn-success'}`}
                        onClick={() => dispatch(toggleBanner(row.original.id))}
                    >
                        {row.original.is_active ? 'Deactivate' : 'Activate'}
                    </button>
                    <button
                        className="btn btn-sm btn-danger removebtn"
                        onClick={() => {
                            if (window.confirm('Are you sure you want to delete this banner?')) {
                                dispatch(removeBanner(row.original.id));
                            }
                        }}
                    >
                        Remove
                    </button>
                </div>
            ),
        },
    ];

    useEffect(() => {
        dispatch(getBanner())
    }, [dispatch])

    return (
        <div className="container-fluid px-4">
            <div className="d-flex justify-content-between align-items-center my-4 flex-wrap" style={{ gap: '0.75rem' }}>
                <div>
                    <h2 className="m-0">Banners</h2>
                    <small className="text-muted">Manage homepage banners</small>
                </div>
                <button className="btn btn-primary" onClick={() => navigate('/banner/add')}>
                    <FaPlus /> Add Banner
                </button>
            </div>

            <div className="card shadow mb-4">
                <div className="card-body p-0">
                    {loading && banners.length === 0 ? (
                        <div className="text-center p-5">Loading...</div>
                    ) : (
                        <AdminTable tableHeaders={tableHeaders} tableData={banners} />
                    )}
                </div>
            </div>
        </div>
    )
}

export default BannerList;
